export default "__VITE_ASSET__BA3xOgY0__"